import React from 'react';

/**
 * Renderiza el bloque SimpleHeader de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function SimpleHeader({
  v
}) {
  return React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "repeat(4,minmax(0,1fr)) 15.625vw",
      "gap": "1.111111vh"
    }
  }, v.text("\n      "), (v.smKpis || []).map((k, index98) => React.createElement(React.Fragment, {
    key: index98
  }, React.createElement("div", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "padding": "1.111111vh 1.481481vh",
      "display": "grid",
      "gridTemplateColumns": "minmax(0,1fr) 7.291667vw",
      "gap": "1.111111vh",
      "alignItems": "center",
      "minWidth": "0"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.37037vh",
      "minWidth": "0"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.203704vh",
      "fontWeight": "600",
      "color": k.c,
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text(k.l)), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "baseline",
      "gap": "0.925926vh",
      "flexWrap": "wrap"
    }
  }, React.createElement("span", {
    style: {
      "font": "600 2.592593vh 'IBM Plex Mono',monospace",
      "lineHeight": "1",
      "color": "#e4e9f0",
      "whiteSpace": "nowrap"
    }
  }, v.text(k.v)), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": k.dc,
      "whiteSpace": "nowrap"
    }
  }, v.text(k.d))), React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#5a667a",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text(k.sub))), v.text("\n        "), React.createElement("svg", {
    "viewBox": "0 0 140 44",
    style: {
      "width": "7.291667vw",
      "height": "4.074074vh",
      "display": "block",
      "overflow": "visible"
    }
  }, React.createElement("path", {
    "d": k.area,
    "fill": k.c,
    "fillOpacity": "0.15"
  }, null), React.createElement("path", {
    "d": k.ref,
    "stroke": "oklch(0.7 0.17 45)",
    "strokeDasharray": "3 3",
    "fill": "none"
  }, null), React.createElement("path", {
    "d": k.line,
    "stroke": k.c,
    "strokeWidth": "1.6",
    "fill": "none",
    "strokeLinejoin": "round"
  }, null), k.hasSeries ? React.createElement("circle", {
    "cx": k.lx,
    "cy": k.ly,
    "r": "3",
    "fill": "#e4e9f0"
  }, null) : null), v.text("\n      ")))), v.text("\n      "), React.createElement("div", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "padding": "0.925926vh 1.296296vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh",
      "justifyContent": "center"
    }
  }, React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "3.229167vw minmax(0,1fr)",
      "gap": "0.740741vh",
      "alignItems": "center"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "textTransform": "uppercase",
      "letterSpacing": "0.05em"
    }
  }, v.text("Alarmas")), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.smNorms || []).map((m, index99) => React.createElement(React.Fragment, {
    key: index99
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "flex": "1",
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.37037vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "fontWeight": m.fw,
      "whiteSpace": "nowrap"
    }
  }, v.text(m.label)))))), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "3.229167vw minmax(0,1fr)",
      "gap": "0.740741vh",
      "alignItems": "center"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "textTransform": "uppercase",
      "letterSpacing": "0.05em"
    }
  }, v.text("Ventana")), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.smWins || []).map((m, index100) => React.createElement(React.Fragment, {
    key: index100
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "flex": "1",
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.37037vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "fontWeight": m.fw,
      "whiteSpace": "nowrap"
    }
  }, v.text(m.label))))))), v.text("\n    "));
}
